import { FC, HTMLAttributes } from "react";
import { useStyles } from "./DeleteAccountPopup.styles";
import { StaticImage } from "../StaticImage";
import { Typography } from "../../core/Typography/Typography";
import {
  TypographyColor,
  TypographyVariant,
} from "../../../constants/typography";
import { Dialog } from "../../core/Dialog/Dialog";
import TrashIcon from "./assets/trash.webp";
import TrashIcon2x from "./assets/trash@2x.webp";
import TrashIcon3x from "./assets/trash.webp";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { removePopupQueue } from "../../../store/slices/popup";
import { PopupType } from "../../../constants/popup";
import { useTranslation } from "react-i18next";

export const DeleteAccountPopup: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { currentPopupId } = useAppSelector((state) => state.popup);

  const onDeleteAccount = () => {
    // TODO: delete account
    dispatch(removePopupQueue({ type: PopupType.DeleteAccount }));
  };
  return (
    <Dialog
      className={classes.root}
      open={currentPopupId === PopupType.DeleteAccount}
      mainAction={{
        text: t("common_Not Now"),
        onClick: () =>
          dispatch(removePopupQueue({ type: PopupType.DeleteAccount })),
      }}
      secondAction={{
        text: t("common_Delete"),
        onClick: onDeleteAccount,
      }}
    >
      <div className={classes.content}>
        <StaticImage
          src={TrashIcon}
          src2x={TrashIcon2x}
          src3x={TrashIcon3x}
          className={classes.currentImage}
        />
        <Typography variant={TypographyVariant.HeadingH5Bold}>
          {t("common_Delete your account?")}
        </Typography>
        <Typography
          variant={TypographyVariant.BodyB5Regular}
          color={TypographyColor.Silver}
        >
          {t(
            " common_Are you sure? This process cannot be undone, you will lose all your data & coins.",
          )}
        </Typography>
      </div>
    </Dialog>
  );
};
